import { ToastContainer, ToastContainerProps } from "react-toastify";
import { Box } from "@mui/material";
import { styledToastContainerStyle } from "@/src/components/StyledToastContainer/styledToastContainerStyle.ts";

export default function StyledToastContainer(props: ToastContainerProps) {
  return (
    <Box sx={styledToastContainerStyle.container}>
      <ToastContainer {...props} />
    </Box>
  );
}
